export function onBlurInputFormData({ formData, setFormData, field }) {
    setFormData({ ...formData, [field]: formData[field].trim() })
}